import Breadcrumb from "@/components/Breadcrumb";
import { useIsMobile } from "@/hooks/use-mobile";
import { memo } from "react";
import { SidebarToggle } from "./SidebarToggle";
import Title from "./Title";

interface PageHeaderProps {
  breadcrumbItems: { label: string; href?: string }[];
  actions?: React.ReactNode;
  title?: React.ReactNode;
}

function PageHeader({ breadcrumbItems, actions, title }: PageHeaderProps) {
  const isMobile = useIsMobile();
  if (isMobile) {
    return (
      <div className="fixed top-0 left-[50px] right-[50px] z-50 flex gap-2 items-center justify-center pb-2 pt-2">
        {actions && <div className="flex gap-2 items-center">{actions}</div>}
      </div>
    );
  }
  return (
    <>
      <div className="flex justify-between items-center pb-2 min-h-[46px]">
        <SidebarToggle />
        <Breadcrumb items={breadcrumbItems} />
        {actions}
      </div>
      {title && <Title className="p-1 mt-2 mb-2">{title}</Title>}
    </>
  );
}

export default memo(PageHeader);
